<template>
  <v-system-bar
    height="36"
    :color="$vuetify.theme.dark ? 'black' : 'white'"
  >
    <v-icon>
      mdi-email-fast-outline
    </v-icon>
    <span class="pr-2 flex-shrink-0">
      {{ $t('label.newsletter_quota_available') }}:
    </span>
    <v-progress-linear
      :value="settings.allowedMessages / settings.createdMessages"
      height="22"
      rounded
      style="max-width: 460px"
    >
      <span class="black--text font-weight-bold text-overline">
        {{ settings.allowedMessages - settings.createdMessages }}/{{ settings.allowedMessages }}
      </span>
    </v-progress-linear>
    <v-spacer />
    <v-icon class="ml-4">
      mdi-email-sync-outline
    </v-icon>
    <span class="flex-shrink-0">
      {{ $t('label.newsletter_quota_reset_date') }}: <span class="font-weight-bold">{{ localized.veryShortDateText(settings.dateQuotaReset) }}</span>
    </span>
  </v-system-bar>
</template>

<script setup lang="ts">

import MarketingCampaignSettings from '@/grpc-api/model/marketing-campaign-settings';
import localized from '@/plugins/vue-localized-formatter/src/localized';
import store from '@/store/store';
import { computed } from 'vue';

const settings = computed(() => store.getters.marketingCampaignSettings as MarketingCampaignSettings);

</script>
